<template>
  <div>
    <span style="font-size: 23px ;font-weight: bold">{{ header }}</span>
    <v-icon style="padding: 20px">fas fa-caret-right</v-icon>
    <span style="font-size: 15px">Edit</span>
  </div>
</template>

<script>
export default {
  props: {
    header: ""
  },
  name: "TitleEdit"
};
</script>

<style scoped></style>
